// Fraunces is the display face of the marketing pages (/, /try, /privacy,
// /dpa, /terms). Each of those routes adds this to its `links()` so the font
// loads in parallel with the page, after root.jsx's preconnects, instead of
// through a render-blocking @import inside the CSS bundle. Inter comes from
// root.jsx and covers every route.
export const FRAUNCES_LINK = {
  rel: "stylesheet",
  href: "https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300..600;1,9..144,300..500&display=swap",
};
